import { render, staticRenderFns } from "./ResourceSettingsPanel.vue?vue&type=template&id=42262c28&scoped=true&lang=pug&"
import script from "./ResourceSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./ResourceSettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42262c28",
  null
  
)

export default component.exports